import {observer} from 'mobx-react';
import RecruitingSubnav from 'main/containers/recruiting/components/RecruitingSubnav';
import InterviewGuideDirectoryWithState from 'main/containers/recruiting/components/interview_guides/InterviewGuideDirectoryWithState';

const InterviewGuideDirectory = observer(({history}) => {
  return (
    <div>
      <RecruitingSubnav />
      <InterviewGuideDirectoryWithState history={history} />
    </div>
  );
});

export default InterviewGuideDirectory;
